
const customRowDisableHook = (hooks) => {
  hooks.prepareRow.push((row) => {
    const originalFn = row.getToggleRowSelectedProps
    row.getToggleRowSelectedProps = () => ({
      disabled: row?.original?.disabled,
      ...(originalFn && originalFn())
    })
  })
}

module.exports = {
  customRowDisableHook
}
